export const SEND_EMAIL 				 = 'SEND_EMAIL'
export const SEND_EMAIL_SUCCESS  = 'SEND_EMAIL_SUCCESS'
export const SEND_EMAIL_FAIL     = 'SEND_EMAIL_FAIL'